import React, { Component } from 'react'

import logoImage from './logo.png'

import {config} from "./config"
import Cookie from "./Cookie"
import api from "./api.js"

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Tooltip from '@material-ui/core/Tooltip'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import Divider from '@material-ui/core/Divider'

import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles'
import withStyles from '@material-ui/core/styles/withStyles'

import ErrorMessageDialog from "./ErrorMessageDialog"

import AwaitRegistrationScreen from "./AwaitRegistrationScreen"
import LoginScreen from "./LoginScreen"
import RegisterScreen from "./RegisterScreen"
import UsersScreen from "./users/UsersScreen"
import InventoryScreen from "./inventory/InventoryScreen"
import TemplatesScreen from "./templates/TemplatesScreen"
import ShowsScreen from "./show/ShowsScreen"
import CategoryScreen from "./inventory/CategoryScreen"
import ImportScreen from "./import/ImportScreen"

import IncomeScreen from "./accounting/IncomeScreen"
import OutcomeScreen from "./accounting/OutcomeScreen"
import BalanceScreen from "./accounting/BalanceScreen"

import backgroundImage from "./background.jpg"

import PurchaseScreen from "./purchase/PurchaseScreen"
import ShopScreen from "./shop/ShopScreen"
import PurchasesTemplatesScreen from './purchases_templates/PurchasesTemplatesScreen'

import CreatePurchaseDialog from './purchase/PurchaseScreen/CreatePurchaseDialog.js'

import BoxesScreen from './boxes/BoxesScreen.js'
import DewarsScreen from './dewars/DewarsScreen.js'

import DewarsAccountingScreen from './dewars-accounting/DewarsAccountingScreen.js'

let menuKeyCounter = 0

const User = React.createContext()

const theme = createMuiTheme({
	typography: {
		useNextVariants: true,
	},
	palette: {
		primary: {main: '#9FCED4'},
	    secondary: {main: '#e64a19'},
	},
});

const styles = theme => ({
	"@global": {
		body: {
			backgroundImage: `url(${backgroundImage})`,
		}
	},
	grow: {
		flexGrow: 1
	},
})

class App extends Component {

	constructor(props) {
		super(props)

		this.state = {
			title: "",
			appBar_userMenuAnchorEl: null,
			drawerOpenState: false,
			user: {
				id: 0,
				name: undefined,
				permission: undefined
			},
			screen: undefined,
			ErrorMessageDialog: undefined
		}

		this.handle_onAttachPurchase = this.handle_onAttachPurchase.bind(this)
		this.handle_onCreatePurchase = this.handle_onCreatePurchase.bind(this)

	}

	handle_onCreatePurchase(purchase) {
		menuKeyCounter++
		this.setState({
			title: "Закупки",
			screen: <PurchaseScreen key = {menuKeyCounter}/>
		})
	}

	handle_onAttachPurchase(items) {
		menuKeyCounter++
		this.setState({
			title: "Закупки",
			screen: <PurchaseScreen key = {menuKeyCounter}/>
		})
	}

	componentDidMount() {
		this.update(() => {
			this.setDefaultScreen(this.state.user)
		})
	}

	setDefaultScreen(user) {
		switch(user.permission) {
			case "1":
			case "nobody":
				menuKeyCounter++
				this.setState({
					title: "Ожидание регистрации",
					screen: <AwaitRegistrationScreen key = {menuKeyCounter}/>
				})
				break
			case "2":
			case "admin":
			case "3":
			case "worker":
			case "4":
			case "artist":
				menuKeyCounter++
				this.setState({
					title: "Шоу",
					screen: <ShowsScreen onCreatePurchase = {this.handle_onCreatePurchase} onAttachPurchase = {this.handle_onAttachPurchase} key = {menuKeyCounter}/>
				})
				break
			default:
				this.setState({
					title: "Вход",
					screen: this._loginScreen()
				})
		}
	}

	_loginScreen(param = {}) {
		menuKeyCounter++
		return <LoginScreen
			key = {menuKeyCounter}
			name = {param.name || ""}
			password = {param.password || ""}
			ErrorMessageDialog = {param.ErrorMessageDialog || ""}
			successHandle = {response => {
				document.cookie = `${config.region.prefix}_sid=${response.sid};path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`
				this.update(() => {
					this.setDefaultScreen(this.state.user)
				})
			}}
			registerHandle = {user => {
				this.setState({
					title: "Регистрация",
					screen: this._registerScreen({
						name: user.name,
						password: user.password
					})
				})
			}}
		/>
	}

	_registerScreen(param = {}) {
		menuKeyCounter++
		return <RegisterScreen
			key = {menuKeyCounter}
			name = {param.name || ""}
			password = {param.password || ""}
			ErrorMessageDialog = {param.ErrorMessageDialog || ""}
			successHandle = {user => {
				this.update(() => {
					this.setDefaultScreen(this.state.user)
				})
			}}
			loginHandle = {user => {
				this.setState({
					title: "Вход",
					screen: this._loginScreen({
						name: user.name,
						password: user.password
					})
				})
			}}
		/>
	}

	update(callback) {
		let xhr = new XMLHttpRequest()
		xhr.open("GET", config.restApiHost + `/session?sid=${Cookie.get("sid")}`, true)
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					let json = JSON.parse(xhr.responseText)
					switch (json["permission"]) {
						case "1":
							json["permission"] = "nobody"
							break
						case "2":
							json["permission"] = "admin"
							break
						case "3":
							json["permission"] = "worker"
							break
						case "4":
							json["permission"] = "actor"
							break
						default:
							json["permission"] = undefined
					}
					this.setState({user: json}, ()=>{
						if (typeof callback == "function") {
							callback(this.state.user)
						}
					})
				} else {
					this.setState({user: {
						id: 0,
						name: undefined,
						permission: undefined
					}}, ()=>{
						if (typeof callback == "function") {
							callback(this.state.user)
						}
					})
				}
			}
		}
		xhr.send()
	}

	render() {

		const {classes} = this.props

    	return <MuiThemeProvider theme = {theme}>

		<User.Provider value = {this.state.user}>

			<ErrorMessageDialog
				message = {this.state.ErrorMessageDialog}
				onClose = {() => {
					this.setState({
						ErrorMessageDialog: undefined
					})
				}}
			/>

			<AppBar
				position = "static"
				style={{
					backgroundImage: `url('${logoImage}')`,
					backgroundRepeat: 'no-repeat',
					backgroundPositionX: 'center',
					backgroundSize: 'contain',
				}}
			>
				<Toolbar>

					<div
						style={{
							position: "absolute",
							right: "0px",
							bottom: "-25px",
							margin: "5px",
							color: "#DDD",
							fontSize: "14px"
						}}
					>
						Наукомания: <div
							style = {{
								display: "inline",
								color: "#FFF"
							}}
						>
							{config.region.name}
						</div>
					</div>

					<User.Consumer>
						{user => <IconButton
							className = {classes.menuButton}
							disabled = {user.permission !== "admin" && user.permission !== "worker"}
							color = "inherit"
							aria-label = "Menu"
							onClick = {()=>{
								this.setState({drawerOpenState: true})
							}}
						>
			              	<MenuIcon />
			            </IconButton>}
					</User.Consumer>
					<Typography
						variant = "h5"
						color = "inherit"
						className = {classes.grow}
					>
						{this.state.title}
					</Typography>
					<User.Consumer>
						{user => user.id === 0 ?
							null
						:
							<React.Fragment>
							<Tooltip title={`Пользователь: ${user.name}`} placement="bottom">
								<IconButton
									color = "inherit"
									onClick = {event => this.setState({
										appBar_userMenuAnchorEl: event.currentTarget
									})}
								>
									<AccountCircle />
								</IconButton>
							</Tooltip>
								<Menu
									id = "appbar-user-menu"
									anchorEl = {this.state.appBar_userMenuAnchorEl}
									anchorOrigin={{
				                    	vertical: 'top',
				                    	horizontal: 'right',
				                    }}
				                    transformOrigin={{
				                    	vertical: 'top',
				                    	horizontal: 'right',
				                    }}
									open = {Boolean(this.state.appBar_userMenuAnchorEl)}
									onClose = {() => this.setState({
										appBar_userMenuAnchorEl: null
									})}
								>

{/* Убираем настроки из меню пользователя, так как отказались от регистрации

									<MenuItem
										onClick = {() => {
											this.setState({
												appBar_userMenuAnchorEl: null
											}, () => {
												this.setState({
													ErrorMessageDialog: "Раздел \"Настроки\" недоступен. Находится в разработке."
												})
											})
										}}
									>Настройки</MenuItem>
*/}

									<MenuItem
										onClick = {() => {
											this.setState({
												appBar_userMenuAnchorEl: null
											}, () => {
												let xhr = new XMLHttpRequest()
												xhr.open("POST", config.restApiHost + `/logout?sid=${Cookie.get("sid")}`, true)
												xhr.onreadystatechange = ()=>{
													if (xhr.readyState === 4) {
														this.update(()=>{
															this.setState({
																title: "Вход",
																screen: this._loginScreen()
															})
														})
													}
												}
												xhr.send()
											})
										}}
									>Выход</MenuItem>
								</Menu>
							</React.Fragment>
						}
					</User.Consumer>

				</Toolbar>
			</AppBar>

			<Drawer
				open = {this.state.drawerOpenState}
				onClose = {() => {
					this.setState({
						drawerOpenState: false
					})
				}}
			>
				<User.Consumer>
					{user => user.id && user.permission === "admin" ?
						<React.Fragment>
							<List subheader={<ListSubheader>Администрирование</ListSubheader>}>
								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Пользователи",
												screen: <UsersScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Пользователи"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Категории инвентаря",
												screen: <CategoryScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Категории инвентаря"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Инвентарь",
												screen: <InventoryScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Инвентарь"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Магазины",
												screen: <ShopScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Магазины"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Шаблоны закупок",
												screen: <PurchasesTemplatesScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Шаблоны закупок"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Шаблоны шоу",
												screen: <TemplatesScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Шаблоны шоу"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Импорт",
												screen: <ImportScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Импорт из csv"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Коробки",
												screen: <BoxesScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Коробки (коды)"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											menuKeyCounter++
											this.setState({
												title: "Сосуды Дьюара",
												screen: <DewarsScreen key = {menuKeyCounter}/>
											})
										})
									}}
								>
									<ListItemText primary="Сосуды Дьюара (коды)"/>
								</ListItem>

							</List>
							<Divider />
						</React.Fragment>
					:
						null
					}
				</User.Consumer>

				<User.Consumer>
					{user => user.id && (user.permission === "admin" || user.permission === "worker") ?
						<React.Fragment>
							<List subheader={<ListSubheader>Управление</ListSubheader>}>
							
								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											this.update(()=>{
												menuKeyCounter++
												this.setState({
													title: "Шоу",
													screen: <ShowsScreen onCreatePurchase = {this.handle_onCreatePurchase} onAttachPurchase = {this.handle_onAttachPurchase} key = {menuKeyCounter}/>
												})
											})
										})
									}}
								>
									<ListItemText primary="Шоу"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											this.update(()=>{
												menuKeyCounter++
												this.setState({
													title: "Закупки",
													screen: <PurchaseScreen key = {menuKeyCounter}/>
												})
											})
										})
									}}
								>
									<ListItemText primary="Закупки"/>
								</ListItem>

								{(() => {
									if (user.permission === "admin") {
										return <ListItem
											button
											onClick = {() => {
												this.setState({
													drawerOpenState : false
												}, () => {
													this.update(()=>{
														menuKeyCounter++
														this.setState({
															title: "Сосуды Дьюара",
															screen: <DewarsAccountingScreen key = {menuKeyCounter}/>
														})
													})
												})
											}}
										>
											<ListItemText primary="Сосуды Дьюара"/>
										</ListItem>
									}
								})()}

							</List>
							<Divider />
						</React.Fragment>
					:
						null
					}
				</User.Consumer>

				<User.Consumer>
					{user => user.id && (user.permission === "admin" || user.permission === "worker") ?
						<React.Fragment>
							<List subheader={<ListSubheader>Учет</ListSubheader>}>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											this.update(()=>{
												menuKeyCounter++
												this.setState({
													title: "Баланс (Остаток)",
													screen: <BalanceScreen key = {menuKeyCounter}/>
												})
											})
										})
									}}
								>
									<ListItemText primary="Баланс (Остаток)"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											this.update(()=>{
												menuKeyCounter++
												this.setState({
													title: "Прием",
													screen: <IncomeScreen key = {menuKeyCounter}/>
												})
											})
										})
									}}
								>
									<ListItemText primary="Прием"/>
								</ListItem>

								<ListItem
									button
									onClick = {() => {
										this.setState({
											drawerOpenState : false
										}, () => {
											this.update(()=>{
												menuKeyCounter++
												this.setState({
													title: "Списание",
													screen: <OutcomeScreen key = {menuKeyCounter}/>
												})
											})
										})
									}}
								>
									<ListItemText primary="Списание"/>
								</ListItem>

							</List>
							<Divider />
						</React.Fragment>
					:
						null
					}
				</User.Consumer>
			</Drawer>

			{this.state.screen ? this.state.screen : null}

		</User.Provider>

		</MuiThemeProvider>

  	}

}

export default withStyles(styles)(App)
